import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Button } from '@osmosis/tailwind-ui/components/Button';
import { P } from '@osmosis/tailwind-ui/components/Text';
import React from 'react';

import { VideoChapter } from '@osmosis/shared/types/learndb/learnData';

import { PROD_MEDIA_SERVER } from '@osmosis/constants';

type ChapterBrowserProps = {
  chapters: VideoChapter[];
  currentPosition: number;
  handleChangePosition: (value: number) => void;
};

/**
 * .
 */
export default function ChapterBrowser({
  chapters,
  currentPosition,
  handleChangePosition,
}: ChapterBrowserProps): JSX.Element {
  return (
    <Box
      id="video-chapters"
      className={`h-[300px] w-[300px] pb-2 overflow-y-scroll rounded-[5px]`}
    >
      {chapters.map(({ title, thumb, chapterID, start }, index) => {
        const nextStart = chapters[index + 1]?.start;
        const position = +start;
        const isCurrent =
          currentPosition >= position && currentPosition < +nextStart;
        return (
          <Button
            key={chapterID}
            type="button"
            variant="transparent"
            color="transparent"
            onClick={(): void => handleChangePosition(position)}
            className={`hover:bg-gray-300 focus:bg-gray-300 w-full justify-start rounded-none p-2 text-left font-normal cursor-pointer`}
            data-testid="chapter-browser-item"
          >
            <img
              src={`${PROD_MEDIA_SERVER}${thumb}`}
              alt=""
              width={70}
              height={40}
            />

            <P
              className={`!ml-2 ${
                isCurrent ? 'text-primary-700 font-bold' : 'text-gray-800'
              }`}
            >
              {title}
            </P>
          </Button>
        );
      })}
    </Box>
  );
}
